import type { SvgIconName } from '../../../components/common/SvgIcon';

export type JourneyGender = 'male' | 'female';
export type JourneyGoal = 'loss' | 'gain' | 'between' | '';

export const JOURNEY_STEP_COUNT = 3;

export const JOURNEY_WEIGHT_MIN = 15;
export const JOURNEY_WEIGHT_MAX = 200;
export const JOURNEY_HEIGHT_MIN = Math.round(2 * 12 * 2.54);
export const JOURNEY_HEIGHT_MAX = Math.round((7 * 12 + 6) * 2.54);
export const JOURNEY_AGE_MIN = 5;
export const JOURNEY_AGE_MAX = 120;

export const JOURNEY_ACTIVITY_OPTIONS: {
  id: string;
  labelKey: string;
  subtitleKey: string;
  api: string;
  icon: SvgIconName;
  tone: 'secondary' | 'primary' | 'success' | 'error';
}[] = [
  {
    id: 'sedentary',
    labelKey: 'journey.sedentary',
    subtitleKey: 'journey.sedentaryShort',
    api: 'Sedentary',
    icon: 'journey-activity-sedentary',
    tone: 'secondary',
  },
  {
    id: 'lightly_active',
    labelKey: 'journey.lightlyActive',
    subtitleKey: 'journey.lightlyActiveShort',
    api: 'Lightly Active',
    icon: 'journey-activity-light',
    tone: 'secondary',
  },
  {
    id: 'moderately_active',
    labelKey: 'journey.moderatelyActive',
    subtitleKey: 'journey.moderatelyActiveShort',
    api: 'Moderately Active',
    icon: 'journey-activity-moderate',
    tone: 'primary',
  },
  {
    id: 'active',
    labelKey: 'journey.active',
    subtitleKey: 'journey.activeShort',
    api: 'Active',
    icon: 'journey-activity-active',
    tone: 'success',
  },
  {
    id: 'very_active',
    labelKey: 'journey.veryActive',
    subtitleKey: 'journey.veryActiveShort',
    api: 'Very Active',
    icon: 'journey-activity-intense',
    tone: 'error',
  },
];

export const JOURNEY_GOAL_OPTIONS: {
  value: JourneyGoal;
  labelKey: string;
  subtitleKey: string;
  icon: SvgIconName;
  tone: 'error' | 'success' | 'secondary';
}[] = [
  { value: 'loss', labelKey: 'journey.weightLoss', subtitleKey: 'journey.goalLossHint', icon: 'journey-goal-loss', tone: 'error' },
  { value: 'gain', labelKey: 'journey.weightGain', subtitleKey: 'journey.goalGainHint', icon: 'journey-goal-gain', tone: 'success' },
  { value: 'between', labelKey: 'journey.maintain', subtitleKey: 'journey.goalMaintainHint', icon: 'journey-goal-maintain', tone: 'secondary' },
];
